import { render, staticRenderFns } from "./SubsOk.vue?vue&type=template&id=78c8cc9c&"
import script from "./SubsOk.vue?vue&type=script&lang=js&"
export * from "./SubsOk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports